import React from "react";

export default function InputText(props) {
  const { required, value } = props;
  return <input type="text" data-required={required} data-required-valid={required && !!value} {...props} />;
}
